const resources = {
    canadaCheckoutText: 'Canada checkout',
    unitedStatesCheckoutText: 'United States checkout'
};

module.exports = function getResource(label) {
    return resources[label];
};
